import { useStoreGtm } from '~/stores/abstract/gtm';
import { useStoreConverterCurrency } from '~/stores/client/converterCurrency';
import { useStoreMatch2One } from '~/stores/services/match2one';
import { useStoreTransactionHistory } from '~/stores/softswiss/transactionHistory';
import { useStoreCurrencyMenu } from '~/stores/strapi/currencyMenu';
import { useOneSignalID } from './useOneSignalID';
import { useMetaPixel } from './usePixel';

export const useAnalytics = () => {
  const storeTransactionHistory = useStoreTransactionHistory();
  const storeConverterCurrency = useStoreConverterCurrency();
  const storeGtm = useStoreGtm();
  const { convertToFormattedAmount } = useCurrencyConverter();
  const storeCurrencyMenu = useStoreCurrencyMenu();

  const deposit = async (isSuccessDeposit: boolean) => {
    await storeTransactionHistory.loadPayments();
    const deposits = storeTransactionHistory.payments.filter((item) => item.action === 'deposit');
    const successfulDeposits = deposits.filter(
      (item) => item.success || item.state === 'succeeded' || item.state === 'accepted'
    );
    const payment = deposits[0];

    const isFTD = !storeTransactionHistory.payments
      .filter((p) => {
        if (p.id && payment && payment.id && payment.id === p.id) {
          return false;
        }
        return true;
      })
      .some((item) => item.success || item.state === 'succeeded' || item.state === 'accepted');

    const isSecondDeposit = successfulDeposits.length === 2 && isSuccessDeposit;

    const isThirdDeposit = successfulDeposits.length === 3 && isSuccessDeposit;

    const isFourthDeposit = successfulDeposits.length === 4 && isSuccessDeposit;

    const isMoreDeposits = successfulDeposits.length > 4 && isSuccessDeposit;

    if (isSuccessDeposit) {
      storeGtm.push({
        event: 'deposit_conversion_successfull',
        payment_method: payment.brand || '',
      });
    }

    console.log(
      isFTD,
      isSecondDeposit,
      isThirdDeposit,
      isFourthDeposit,
      successfulDeposits,
      deposits
    );

    let currency = payment.currency;

    if (currency === 'DOG') {
      currency = 'DOGE';
    }

    if (isFTD && isSuccessDeposit) {
      useOneSignalID().setUserGroup('deposit');

      useStoreMatch2One().trigger('FirstTimeDeposit', {
        order_id: payment.id,
        order_value: payment.formated_cent,
        order_currency_code: currency,
      });
    } else if (isSecondDeposit) {
      useOneSignalID().setUserGroup({
        deposit: 'true',
        deposit2: 'true',
      });
    } else if (isThirdDeposit) {
      useOneSignalID().setUserGroup({
        deposit: 'true',
        deposit2: 'true',
        deposit3: 'true',
      });
    } else if (isFourthDeposit || isMoreDeposits) {
      useOneSignalID().setUserGroup({
        deposit: 'true',
        deposit2: 'true',
        deposit3: 'true',
        deposit4: 'true',
      });
    }

    if (isSuccessDeposit) {
      if (storeCurrencyMenu.isCryptoCurency(payment.currency)) {
        const price =
          storeConverterCurrency.getPrice(
            {
              from: payment.currency,
              to: 'USD',
            },
            true
          ) || 0;
        const { formattedAmount } = convertToFormattedAmount(
          (payment.formated_cent || 0) * price,
          'USD',
          true
        );
        useMetaPixel().sendEvent('Purchase', { currency: 'USD', value: Number(formattedAmount) });
      } else {
        useMetaPixel().sendEvent('Purchase', {
          currency: payment.currency,
          value: payment.formated_cent,
        });
      }

      // Pixel Match2One deposit
      if (!isFTD && isSuccessDeposit) {
        useStoreMatch2One().trigger('Deposit', {
          order_id: payment.id,
          order_value: payment.formated_cent,
          order_currency_code: currency,
        });
      }
    }
  };

  return {
    deposit,
  };
};
